export const ResponsiveBR = () => <br className="hidden tablet:inline" />;
